jQuery(function ($) {
  if ($('.staff__hero__gallery')[0]) {
    // initialize masonry, then trigger layout after each image loads
    const grid = $('.staff__hero__gallery-grid').masonry({
      itemSelector: '.staff__hero__gallery-grid-item',
      horizontalOrder: true,
      percentPosition: true,
      columnWidth: '.staff__hero__gallery-grid-sizer',
      gutter: 10,
    });
    grid.imagesLoaded().progress(function () {
      grid.masonry('layout');
    });
    // initialize masonry after all images have been loaded
    // const grid = $('.staff__hero__gallery-grid').imagesLoaded(function () {
    //   grid.masonry({
    //     itemSelector: '.staff__hero__gallery-grid-item',
    //     horizontalOrder: true,
    //     percentPosition: true,
    //     columnWidth: '.staff__hero__gallery-grid-sizer',
    //     gutter: 10,
    //   });
    // });
  }
});
